(function ($) {
    $(document).ready(function () {
        var updateCurrentQuestion = function () {
            if (!rissb_var.token) {
                return;
            }

            var data = {
                question: $('.gform_page').filter(':visible').find('.gfield_label').first().text(),
                entryId: $('.partial_entry_id').val(),
            };

            $.post('/api/survey/respondent/' + rissb_var.token +'/updateCurrentQuestion', data, function (res) {
            });
        };

        var updateNavigationButton = function () {
            $('.gform_next_button').attr('value', 'Next >');
            $('.gform_previous_button').attr('value', '< Previous');
            $('.gform-footer-wrapper').empty().append($('.gform_page').filter(':visible').find('.gform_page_footer').clone(true));
        };

        var updatePreviewEntryId = function () {
            if (!rissb_var.preview) {
                return;
            }

            if (!rissb_var.survey_id) {
                return;
            }

            var entryId = $('.partial_entry_id').val();

            $.post('/api/survey/preview/' + rissb_var.preview +'/updateEntryId', {entryId: entryId, surveyId: rissb_var.survey_id}, function (res) {
            });
        };

        $('.js-form-start-survey').on('submit', function (e) {
            var $checkboxes = $('.checkboxes').find('input[type="checkbox"]');

            if ($checkboxes.length && $checkboxes.length !== $checkboxes.filter(':checked').length) {
                alert('Please tick all checkbox before you proceed.');
                e.preventDefault();
                return;
            }
        });

        if ($('body').hasClass('single-survey-iteration')) {
            $(window).on('load', updateCurrentQuestion);
            $(window).on('load', updateNavigationButton);
            //$(window).on('load', updatePreviewEntryId);

            /*$(window).on('load', function () {
                $('.gform_wrapper').find('form').garlic();
            });*/

           /* $(document).on('heartbeat-tick', function(e, data) {
                if (!data['gf-partial-entries-ids']) {
                    return;
                }

                if (!rissb_var.token) {
                    return;
                }

                $.each(data['gf-partial-entries-ids'], function (formId, entryId) {
                    $.post('/api/survey/respondent/' + rissb_var.token +'/updateEntryId', {entryId: entryId}, function (res) {
                    });
                });
            });

            $(document).on('heartbeat-tick', function(e, data) {
                if (!data['gf-partial-entries-ids']) {
                    return;
                }

                if (!rissb_var.preview) {
                    return;
                }

                if (!rissb_var.survey_id) {
                    return;
                }

                $.each(data['gf-partial-entries-ids'], function (formId, entryId) {
                    $.post('/api/survey/preview/' + rissb_var.preview +'/updateEntryId', {entryId: entryId, surveyId: rissb_var.survey_id}, function (res) {
                    });
                });
            });*/

            $(document).on('click', '.survey-form-wrapper .gform_next_button, .survey-form-wrapper .gform_previous_button, .survey-form-wrapper input[type="submit"]', function (e) {
                var token;
                var data = {
                    formdata: $('.survey-form-wrapper .gform_wrapper form').serialize(),
                    surveyId: rissb_var.survey_id,
                };

                if (rissb_var.preview) {
                    token = rissb_var.preview;
                } else {
                    token = rissb_var.token;
                }

                $.post('/api/survey/' + token + '/updateSurveyEntryData', data, function (res) {
                });
            });
        }

        $('#modal-setup-survey').on('shown.bs.modal', function () {
            var $requestSurveyForm = RISSB.fn.ajaxForm({
                form: '.js-form-request-survey',
                clearForm: true,
                beforeSubmitCb: function () {
                    var message = $.trim($('[name="message"]').val());

                    if (message.length < 3) {
                        alert('Please enter your message (minimum 3 characters)');
                        return false;
                    }

                    return true;
                },
                successCb: function () {
                    $('#modal-setup-survey').modal('hide');
                    $('#modal-setup-survey-thank-you').modal('show');
                },
            });
        });
    });
})(jQuery);

